import {CoreObjectArchiveData} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {FieldDefinitionType} from 'graphql-client/__generated/graphqlGlobalTypes';

export const LIBRARY_PARAMETER_DEFINITION_DATA_TYPES = [
  FieldDefinitionType.FLOAT,
  FieldDefinitionType.TEXT,
  FieldDefinitionType.DATETIME,
];

export function isLibraryParameterDefinitionDataType(
  dataType: FieldDefinitionType
): dataType is LibraryParameterDefinitionDataType {
  return LIBRARY_PARAMETER_DEFINITION_DATA_TYPES.includes(dataType);
}

export type LibraryParameterDefinitionDataType =
  | FieldDefinitionType.FLOAT
  | FieldDefinitionType.TEXT
  | FieldDefinitionType.DATETIME;

export interface LibraryParameterDefinition {
  id: string;
  name: string;
  dataType: LibraryParameterDefinitionDataType;
  unitType: {id: string; name: string} | null;
  description: string | null;
  archiveData: CoreObjectArchiveData;
}
